import { render, staticRenderFns } from "./DiscountEdit.vue?vue&type=template&id=5fd2ec9b&scoped=true&"
import script from "./DiscountEdit.vue?vue&type=script&lang=js&"
export * from "./DiscountEdit.vue?vue&type=script&lang=js&"
import style0 from "./DiscountEdit.vue?vue&type=style&index=0&id=5fd2ec9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2ec9b",
  null
  
)

export default component.exports